.ux-autosuggest-input {
  display: block;
  position: relative;

  .ux-input {
    background-color: var(--ux-input-background-color);
    border-color: var(--ux-input-border-color);
  }

  .ux-input:not(:disabled) {
    &:hover:not(:focus) {
      background-color: var(--ux-input-hover-bg);
      border-color: var(--ux-input-hover-border-color);
      color: var(--ux-input-hover-text-color);
    }

    &:focus {
      background-color: var(--ux-input-background-color);
      border-color: var(--ux-input-focus-border-color);
      color: var(--ux-input-focus-text-color);
      outline: var(--ux-input-focus-border-color) solid var(--ux-input-outline-width);
      outline-offset: var(--ux-input-outline-offset);
    }

    &:active {
      background-color: var(--ux-input-active-bg);
      border-color: var(--ux-input-focus-border-color);
      outline: var(--ux-input-active-border-color) solid var(--ux-input-outline-width);
      outline-offset: var(--ux-input-outline-offset);
    }

    &::placeholder {
      color: var(--ux-input-placeholder-color);
      font-weight: var(--ux-input-placeholder-font-weight);
    }
  }

  &__input-container {
    background-color: var(--ux-input-background-color);
    position: relative;
  }

  &__suggestions {
    border: var(--ux-input-border-width) solid var(--ux-input-focus-border-color);
    border-top-width: 0;
    left: 0;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: $z-index-dropdown-element;

    .ux-suggest-item {
      pointer-events: auto;
    }

    &--slim {
      border-top: 0;
      max-height: 230px;
      overflow-y: scroll;
    }
  }

  &__suggestions--hidden {
    border: 0;
    display: none;
  }

  &__suggestion-link {
    display: block;
    text-decoration: none;

    &:last-child .ux-autosuggest-item--slim {
      border: 0;
    }
  }

  .ux-form-group--error &,
  &--error {
    .ux-input:not(:disabled) {
      border-color: var(--ux-input-error-border-color);
    }

    .ux-input:not(:disabled):not(:focus):hover {
      border-color: var(--ux-input-error-hover-border-color);
    }
  }

  .ux-form-group--disabled &,
  &--disabled {
    .ux-input {
      background-color: var(--ux-input-disabled-bg);
      border-color: var(--ux-input-disabled-border-color);
      color: var(--ux-input-disabled-text-color);
      opacity: var(--ux-input-disabled-opacity);
    }
  }
}
